import { gsap } from 'gsap';
import { Draggable } from 'gsap/Draggable';

export default class DraggableNav {
  constructor() {
    // capture main and nav references
    this.main = document.getElementById('main');
    this.nav = document.querySelector('.bloomies-nav');
    this.navCollection = document.querySelectorAll('.bloomies-nav li');
    this.navCell = document.querySelector('.bloomies-nav .cell');
    this.navPosition = document.querySelector('.bloomies-nav-position');

    // nav width
    this.dragMinX = 0;
  }

  init() {
    if (this.main && this.navCell) {
      // update drag boundaries for mobile nav
      this.updateDragX(this.navCell.offsetWidth, window.innerWidth);

      // init app
      this.initGsap();
      this.initNavScroll();
      this.addResizeListener();
    }
  }

  initGsap() {
    gsap.registerPlugin(Draggable);

    Draggable.create(this.navCell, {
      type: 'x',
      bounds: {
        minX: this.dragMinX,
        maxX: 0,
      },
    });
  }

  initNavScroll() {
    // on scroll update active nav items
    window.addEventListener('scroll', () => {
      this.handleScroll();
    });
  }

  handleScroll() {
    const top = window.pageYOffset || document.documentElement.scrollTop;

    // position sticky nav based on scroll position
    // console.log(this.main);
    if (this.main) {
      const mainOffset = this.main.offsetTop || 0;
      const navOffset = this.navPosition.offsetTop || 0;
      this.checkStickyNav(top, mainOffset, navOffset);
    }
  }

  checkStickyNav(top, mainOffset, navPlaceholderOffset) {
    if (top > mainOffset + navPlaceholderOffset) {
      this.main.classList.add('sticky');
    } else {
      this.main.classList.remove('sticky');
    }
  }

  updateDragX(navWidth, windowWidth) {
    this.dragMinX = -(navWidth - windowWidth);
    if (this.dragMinX >= 0) {
      this.dragMinX = 0;
    }
  }

  addResizeListener() {
    // listen for window resize
    window.addEventListener('resize', () => {
      // update drag min
      this.updateDragX(this.navCell.offsetWidth, window.innerWidth);
      Draggable.get(this.navCell).applyBounds({ minX: this.dragMinX, maxX: 0 });
    });
  }
}



// WEBPACK FOOTER //
// /home/jenkins/agent/workspace/marketing-campaigns_deploy_trigger_bcom_v2/package/src/js/draggableNav.js